var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUpArrow = function SvgIconUpArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 10 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.57 5.06.937.941L4.32 3.183V13h1.362V3.183L8.5 6.001l.932-.94L5.002.63z"
  })));
};
export default SvgIconUpArrow;